import { axiosInstance } from '.';
import { MarketIntegrationResponseType, MarketVerificationResponseType } from '../../types/marketplaceIntegration';

export const marketIntegrationService = {
    async fetchTheIntegrations({ companyId = '', page = 1, limit = 10 }) {
        const { data } = await axiosInstance.get(`MarketPlace/GetMarketPlaceDetails`, {
            params: { companyId, page, limit },
        });
        return data as MarketIntegrationResponseType;
    },

    async verifyIntegrationApiKey(companyId: string, endpointId: string, apiKey: string) {
        const { data } = await axiosInstance.post('MarketPlace/ValidateAPIKey', { companyId, endpointId, apiKey });
        return data;
    },

    async confirmConsent() {
        const { data } = await axiosInstance.post(`confirm-consent`);
        return data as MarketVerificationResponseType;
    },

    async verifyCloudflareToken(token: string) {
        const { data } = await axiosInstance.post(`MarketPlace/VerifyValidRequest`, { token });
        return data;
    },

    async installKekaWorkflow(code: string, token: string) {
        const { data } = await axiosInstance.post('MarketPlace/InstallKekaWorkflow', {
            start: 0,
            limit: 0,
            code: code,
            token: token,
        });
        return data;
    },
};
